import * as React from "react";
import type { SVGProps } from "react";
const SvgIconLike = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.26 1.35c-.23.03-.36.06-.55.15-.27.11-.56.35-.72.58L5.71 4.13 4.5 6.07l-.71.01h-.71l-.1.05c-.1.05-.22.17-.28.28-.05.12-.06.32-.01.45s.2.27.32.32c.1.04.1.04 1.04.03h.93l.09-.05.14-.1c.04-.04.65-1.01 1.38-2.19.86-1.38 1.35-2.15 1.4-2.2q.06-.08.16-.12c.09-.04.11-.05.26-.05s.17 0 .26.06q.28.14.34.45l.01 1.67c0 1.54 0 1.56.04 1.65.04.11.16.25.28.3l.1.05h2.18c2.04.02 2.18.02 2.25.04q.28.12.4.36c.08.2.1.07-.38 3.03l-.47 2.77c-.04.1-.18.26-.28.31-.15.08.08.07-5.09.07-3.54 0-4.89 0-4.95.02l-.15.05c-.08.04-.2.17-.25.26-.03.07-.04.1-.04.24s0 .17.04.25q.14.27.45.32c.07.01 1.64.02 5 .01h4.91l.15-.04c.36-.08.61-.22.88-.49q.32-.31.45-.72l.48-2.86c.43-2.66.44-2.71.44-2.95 0-.19 0-.27-.03-.38-.17-.75-.76-1.29-1.5-1.4-.08-.01-.7-.02-1.95-.02h-1.82V2.82l-.05-.15c-.05-.18-.16-.41-.26-.56-.15-.22-.42-.46-.67-.59s-.65-.2-.92-.17M.94 6.1c-.2.06-.36.24-.4.44v7.44l.05.1q.15.32.52.32c.1 0 .14 0 .22-.04q.3-.14.33-.47.03-.14.02-3.74V6.54l-.04-.1q-.15-.32-.5-.35z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconLike;
